<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <div class="row">
            <!-- <div col-lg-12 v-if="showAlertMessage" class="alert alert-danger">
                {{ alertMessage }}
            </div> -->
            <div class="contentbox">
                <div v-if="showAlertMessage" class="alert alert-danger m-b-10">
                    <strong>{{ alertMessage }}</strong> <span data-dismiss="alert" class="close"><i
                            class="icon-remove"></i></span>
                </div>
            </div>

            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Send Survey</h4>
                    </div>
                    <div class="card-body">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col-md-4 col-sm-6 form-group">
                                    <input type="hidden" name="autocompletePractice" id="autocompletePractice">
                                    <input class="form-control" v-model="serverParams.customFilters.name" type="text"
                                        name="search" id="search" placeholder="Search" @keyup="loadItems()">
                                </div>
                                <div class="col-md-4 col-sm-6">
                                    <b-form-group label-for="ReferredBy">
                                        <b-form-select name="ReferredBy" v-model="surveyParam.surveyID"
                                            :options="surveys" class="mb-3" value-field="item" text-field="name">
                                        </b-form-select>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-4 form-group"
                                    style="font-size:13px; font-weight:300">
                                    <input name="reset" type="reset" value="Send Email" @click="sendSurvey()"
                                        class="btn btn-success btn-xs btn-rounded p-l-10 p-r-10">
                                    <input name="reset" type="reset" value="Preview" @click="previewSurvey()"
                                        class="btn btn-success btn-xs btn-rounded ml-1 p-l-10 p-r-10">
                                </div>
                            </div>
                        </div>
                        <CircleLoader v-if="isLoading" />
                        <vue-good-table ref="my-table" mode="remote" :totalRows="totalRecords" :isLoading="isLoading"
                            :pagination-options="{
                                enabled: true,
                                perPage: serverParams.perPage,
                                perPageDropdown: [10, 20, 50, 100, 200],
                            }" :sort-options="{
                                enabled: true,
                                initialSortBy: {
                                    field: 'PracticeID',
                                    type: 'desc',
                                },
                            }" :rows="rows" :columns="columns" :select-options="selectOptions"
                            @on-page-change="onPageChange" @on-per-page-change="onPerPageChange"
                            @on-sort-change="onSortChange" @on-selected-rows-change="selectionChanged">
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue from "vue";
import VueJsonToCsv from 'vue-json-to-csv'
import SortedTablePlugin from "vue-sorted-table";
import API from '@/api'
import CircleLoader from '@/pages/loaders/CircleLoader.vue';
Vue.component('vue-json-to-csv', VueJsonToCsv)
Vue.use(SortedTablePlugin, {
    ascIcon: '<i class="ti-arrow-down"></i>',
    descIcon: '<i class="ti-arrow-up"></i>'
});
export default {
    name: 'Spotters',
    data() {
        return {
            isDisabled: false,
            selected: true,
            unSelected: false,
            showAlertMessage: false,
            alertMessage: '',
            serverParams: {
                customFilters: {
                    status: '',
                    memberStatus: '',
                    name: ''
                },
                sort: [
                    {
                        field: 'PracticeID', // example: 'name'
                        type: 'desc' // 'asc' or 'desc'
                    }
                ],

                page: 1, // what page I want to show
                perPage: 10 // how many items I'm showing per page
            },
            surveys: [{ item: '', name: 'Select Survey' }],
            columns: [
                {
                    label: 'Practice',
                    field: 'PracticeName',
                    filterable: true,
                },
                {
                    label: 'Position',
                    field: 'Status',
                    sortable: true,
                },
                {
                    label: 'Email',
                    field: "email",
                    sortable: true,
                },
                {
                    label: 'Name',
                    field: "Name",
                    sortable: true,
                }
            ],
            isLoading: false,
            rows: [],
            selectOptions: {
                enabled: true
            },
            totalRecords: 0,
            spots: [],
            surveyParam: {
                userIdList: [],
                surveyID: '',
            }
        };
    },
    methods: {
        editMember(member) {
            this.$router.push({ name: 'edit_Member', params: { user: member } });
        },
        // previewSurvey() {
        //     this.$router.push({ name: 'preview_survey', params: { surveyID: this.surveyParam.surveyID } });
        // },
        previewSurvey() {
            if (this.surveyParam && this.surveyParam.surveyID) {
                this.$router.push({ name: 'preview_survey', params: { surveyID: this.surveyParam.surveyID } });
            } else {
                this.showAlertMessage = true;
                this.alertMessage = 'Please select survey!';
            }
        },
        sendSurvey() {
            if (!this.surveyParam.surveyID) {
                this.showAlertMessage = true;
                this.alertMessage = 'Please select survey!';
                return;
            }

            const params = {
                userIdList: this.surveyParam.userIdList,
                surveyID: this.surveyParam.surveyID,
            };

            API.sendSurveys(params,
                data => {
                    this.isDisabled = false;

                    if (this.surveyParam && this.surveyParam.surveyID) {
                        this.$showNotification({ message: 'Survey sent Successfully' }, "success")
                    }
                    else {
                        this.showAlertMessage = true;
                        this.alertMessage = 'Please select survey!';
                    }
                },
                err => {
                    this.isDisabled = false;
                }
            )
        },
        surveyList() {
            API.getAllSurveys(this.serverParams,
                data => {
                    data.data.data.forEach((survey) => {
                        this.surveys.push({
                            item: survey.id,
                            name: survey.surveyName,
                        });
                    });
                }, err => {
                })
        },
        loadItems() {
            this.isLoading = true;
            API.getAllMembers(this.serverParams,
                data => {
                    this.totalRecords = data.totalRecords;
                    this.rows = data.data
                    this.rows.map(q => {
                        const DataForCSV = q != null ? {
                            Position: q.Status,
                            Username: q.FirstName + ' ' + q.LastName,
                            MemberStatus: q.MemberStatus,
                            Email: q.email,
                            Address1: q.Address1,
                            Address2: q.Address2,
                            City: q.City,
                            State: q.StateID,
                            Phone1: q.Phone1,
                            Phone2: q.Phone2
                        } :
                            {};
                        const sp = {
                            spot_id: q != null ? q.UserID : 0,
                            spot_status: q != null ? (q.MemberStatus === 'Active' ? true : false) : false,
                        }
                        this.CSVData.push(DataForCSV);
                        this.spots.push(sp);
                        console.log('MemberStatus :', this.MemberStatus);
                        this.isLoading = false;
                    });
                }, err => {
                    this.isLoading = false;
                })
        },

        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        selectionChanged(params) {
            // Clear the userIdList array
            this.surveyParam.userIdList = [];

            // Add selected userIds to the userIdList array
            params.selectedRows.forEach(q => {
                this.surveyParam.userIdList.push(q.UserID);
            });
        },
        // selectionChanged:function(){
        //     this.$refs['my-table'].selectedRows;
        // },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.loadItems();
        },
        changeStatus(spot_id, event) {
            const data = {
                id: spot_id,
                status: (event.value === true) ? 'Active' : 'Inactive',
            }
            API.updateMemberStatus(data,
                data => {
                    if (data.status === 200) {
                        this.$showNotification(data, "success")
                    }
                }, this.errorMsg)
        },
        errorMsg(err) {
            console.log(err);
            this.$showNotification({ message: 'Failed system error' }, "error")
        },
        onSortChange(params) {
            Vue.set(this.serverParams.sort, 0, {
                field: params[0].field,
                type: params[0].type,
            });
            this.loadItems();
        },


    },
    computed: {}
    ,
    mounted() {
        this.loadItems();
        this.surveyList();
    }
}
</script>
